import { render, staticRenderFns } from "./CarouselAutoSettings.vue?vue&type=template&id=11f824ca&scoped=true"
import script from "./CarouselAutoSettings.vue?vue&type=script&lang=js"
export * from "./CarouselAutoSettings.vue?vue&type=script&lang=js"
import style0 from "./CarouselAutoSettings.vue?vue&type=style&index=0&id=11f824ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f824ca",
  null
  
)

export default component.exports